import { render, staticRenderFns } from "./ComplaintsFiltersStateFormField.vue?vue&type=template&id=cf2243f8&lang=pug&"
import script from "./ComplaintsFiltersStateFormField.vue?vue&type=script&lang=ts&"
export * from "./ComplaintsFiltersStateFormField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports